/* eslint-disable @typescript-eslint/naming-convention */
export enum ETagsActionType {
	GET_TAGS = 'getTags',
}
